export default __webpack_public_path__ + "static/imperfective-future-e5542b283e443890e8417b730b53c90b.svg";